module.exports = __webpack_public_path__ + "img/about-us.1d5d0e2b.svg";